export class ProjectsFilter {
	constructor() {
		this.filter = document.querySelector("[data-filter]");
		if (!this.filter) return;

		this.buttons = this.filter.querySelectorAll("[data-filter-value]");
		this.projects = document.querySelectorAll("[data-tags]");

		this.init();
		this.checkHash();
	}

	init() {
		// Filter button clicks
		this.buttons.forEach((button) => {
			button.addEventListener("click", () =>
				this.filterBy(button.dataset.filterValue, true)
			);
		});

		// Tag clicks on project cards
		document.querySelectorAll("[data-tag-value]").forEach((tag) => {
			tag.addEventListener("click", () => {
				const value = tag.dataset.tagValue;
				this.filterBy(value, true);
				this.scrollToFilter();
			});
		});
	}

	checkHash() {
		const hash = location.hash.slice(1);
		if (!hash) return;

		// Check if hash matches a filter value
		const matchingButton = Array.from(this.buttons).find(
			(btn) => btn.dataset.filterValue === hash
		);

		if (matchingButton) {
			this.filterBy(hash, false);
		}
	}

	filterBy(value, updateHash = true) {
		// Update button states
		this.buttons.forEach((btn) => {
			btn.setAttribute("aria-pressed", btn.dataset.filterValue === value);
		});

		// Show/hide projects
		this.projects.forEach((project) => {
			const tags = project.dataset.tags.split(" ");
			const show = value === "all" || tags.includes(value);
			project.hidden = !show;
		});

		// Update URL hash
		if (updateHash) {
			if (value === "all") {
				history.replaceState(null, "", location.pathname);
			} else {
				history.replaceState(null, "", "#" + value);
			}
		}

		// Notify other components that layout changed
		window.dispatchEvent(new CustomEvent("projects-filtered"));
	}

	scrollToFilter() {
		this.filter.scrollIntoView({ behavior: "smooth", block: "start" });
	}
}
